import { gql } from "@apollo/client"

// TTPSP-140 will implement this end point. Implementation copied from 140 draft
//     schema.
export const VERIFY = gql`
    mutation verify($STAToken: String!) {
        verify(token: $STAToken) {
            accessToken
        }
    }
`
